import ThemesManager from "@/banner_template/themes/ThemeManager";

export const ThemesContainerSingleton = new ThemesManager();